import { useContext } from "react";
import { PricesDrawerContext } from "./PricesDrawerProvider";

export const usePricesDrawer = () => useContext(PricesDrawerContext);
